import React, { useEffect } from 'react';
import Navbar from '../components/landing/Navbar';
import Hero from '../components/landing/Hero';
import ValueSection from '../components/landing/ValueSection';
import FeaturesBento from '../components/landing/FeaturesBento';
import RoleExperience from '../components/landing/RoleExperience';
import HowItWorks from '../components/landing/HowItWorks';
import ProductShowcase from '../components/landing/ProductShowcase';
import Benefits from '../components/landing/Benefits';
import TrustSection from '../components/landing/TrustSection';
import FinalCTA from '../components/landing/FinalCTA';
import Footer from '../components/landing/Footer';

export default function LandingPage() {
  useEffect(() => {
    document.title = 'EduPortal — Modern School Management Platform';

    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = 'EduPortal connects administrators, teachers, students, and parents in one modern school management platform for attendance, quizzes, assignments, timetables, and academic reporting.';
  }, []);

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 font-sora selection:bg-blue-500 selection:text-white overflow-x-hidden antialiased">
      {/* Sticky Header */}
      <Navbar />

      {/* Main Content Sections */}
      <main id="main-content">
        <Hero />
        <ValueSection />
        <FeaturesBento />
        <RoleExperience />
        <HowItWorks />
        <ProductShowcase />
        <Benefits />
        <TrustSection />
        <FinalCTA />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}
